// extracted by mini-css-extract-plugin
export default {"usuallySpend":"usuallySpend--mp-jpKOn"};